import { Alert, Modal, Radio, Space, Typography } from "antd";
import { useEffect, useState } from "react";

export function InvoicePdfOptionsModal({
  open,
  invoiceCount = 1,
  loading = false,
  onCancel,
  onGenerate
}: {
  open: boolean;
  invoiceCount?: number;
  loading?: boolean;
  onCancel: () => void;
  onGenerate: (roundToNearestRupee: boolean) => void | Promise<void>;
}) {
  const [roundToNearestRupee, setRoundToNearestRupee] = useState(true);

  useEffect(() => {
    if (open) setRoundToNearestRupee(true);
  }, [open]);

  return (
    <Modal
      title={`Generate Invoice PDF${invoiceCount > 1 ? ` (${invoiceCount})` : ""}`}
      open={open}
      okText="Generate PDF"
      cancelText="Cancel"
      confirmLoading={loading}
      onCancel={onCancel}
      onOk={() => onGenerate(roundToNearestRupee)}
      destroyOnClose
      width={520}
      className="compact-switch-modal"
    >
      <Space direction="vertical" size={14} style={{ width: "100%" }}>
        <div>
          <Typography.Text strong>Payable amount rounding</Typography.Text>
          <Radio.Group
            style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 10 }}
            value={roundToNearestRupee ? "nearest" : "exact"}
            onChange={(event) => setRoundToNearestRupee(event.target.value === "nearest")}
          >
            <Radio value="nearest">Round net payable to the nearest rupee</Radio>
            <Radio value="exact">Keep exact rupees and paise</Radio>
          </Radio.Group>
        </div>
        <Alert
          showIcon
          type="info"
          message="Invoice calculation"
          description="Gross Bill = Taxable Amount + GST. Net Payable = Gross Bill − TDS ± Round-off."
        />
      </Space>
    </Modal>
  );
}
